import React from "react";

import CatalogCrudPage from "./CatalogCrudPage";
import { brandsService } from "../../services";

export default function BrandsPage() {
  return (
    <CatalogCrudPage
      title="Marcas"
      subtitle="Administracion de marcas"
      addTabPath="/settings/brands"
      addTabLabel="Marcas"
      service={brandsService}
      hasDescription
      viewPerms={["view_brands"]}
      managePerms={["manage_brands"]}
    />
  );
}
